import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CalendarIcon, ClockIcon } from 'lucide-react';
const posts = [{
  slug: 'we-built-a-custom-erp-at-a-rocket-factory',
  title: "We Built a Custom ERP at a Rocket Factory. Here's What We Learned.",
  excerpt: "How Astra Space built AstraOS — inspired by SpaceX's Warp Drive — and why we're bringing that playbook into the AI era at Thruline.",
  date: 'March 9, 2026',
  readTime: '18 min read',
  category: 'Company',
  image: 'https://images.unsplash.com/photo-1541185933-ef5d8ed016c2?auto=format&fit=crop&q=80&w=800&h=400'
}, {
  slug: 'custom-erp-vs-pre-configured-solutions-which-is-better-for-your-manufacturing-business',
  title: 'Custom ERP vs Pre-Configured Solutions: Which Is Better For Your Manufacturing Business?',
  excerpt: "The choice between a custom ERP solution and a pre-configured system isn't just about software: it's about aligning your technology infrastructure with your manufacturing processes, growth plans, and competitive strategy.",
  date: 'September 29, 2025',
  readTime: '10 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/68dad5a0f6141102b92506e9_customERPImage.jpeg'
}, {
  slug: '7-mistakes-youre-making-with-erp-integrations-and-how-to-fix-them',
  title: "7 Mistakes You're Making with ERP Integrations (and How to Fix Them)",
  excerpt: "ERP integrations can make or break your manufacturing operations. After working with countless manufacturing companies, we've seen the same integration mistakes repeated over and over.",
  date: 'September 29, 2025',
  readTime: '8 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/68daefefa23275116fd19b03_7IntegrationMistakesPicture.webp'
}, {
  slug: 'manufacture-your-way-not-theirs',
  title: 'Manufacture Your Way, Not Theirs',
  excerpt: "Make sure your solutions are customized to match your company's processes. Changing your process to match a software system takes away one of the greatest competitive edges your company has.",
  date: 'July 8, 2025',
  readTime: '4 min read',
  category: 'Manufacturing',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/686c78e06c5d68dee8d6bca4_lenny-kuhne-jHZ70nRk7Ns-unsplash.jpeg'
}, {
  slug: 'what-it-takes-to-do-a-60-day-erp-implementation',
  title: 'What it Takes to Do a 60-Day ERP Implementation',
  excerpt: 'Remember when getting an ERP system up and running felt like planning a moon landing? The 60-day implementation timeline represents a fundamental shift in how smart companies approach enterprise software.',
  date: 'December 2, 2025',
  readTime: '8 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/692e78b9f019f5dc0ec3c3f4_iyIA9nMudnm.webp'
}, {
  slug: 'struggling-with-inventory-chaos-7-signs-your-manufacturing-business-needs-better-inventory-management-software',
  title: '7 Signs Your Manufacturing Business Needs Better Inventory Management Software',
  excerpt: 'How do you know when your inventory management has crossed the line from "quirky" to "completely dysfunctional"? Here are seven telltale signs it\'s time to ditch the spreadsheets.',
  date: 'October 4, 2025',
  readTime: '9 min read',
  category: 'Inventory',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/68e15fcd8ae5b2178127b8cb_LL7OxqSoHbt.webp'
}, {
  slug: 'how-companies-handle-engineer-purchase-requests-three-approaches-to-procurement',
  title: 'How Companies Handle Engineer Purchase Requests: Three Approaches to Procurement',
  excerpt: "In the fast-paced world of engineering, efficient procurement processes can make or break project timelines. Let's explore the three main organizational structures and how accounting teams manage these transactions.",
  date: 'May 4, 2025',
  readTime: '5 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/6817af69c7cc8e82d7e50670_ChatGPT%20Image%20May%203%2C%202025%2C%2009_51_59%20AM.jpg'
}, {
  slug: 'how-manufacturing-methodologies-shape-erp-system-needs',
  title: 'How Manufacturing Methodologies Shape ERP System Needs',
  excerpt: 'The way a manufacturer operates impacts the effectiveness of its ERP system. While two companies might produce similar products, the processes behind their operations can vary significantly.',
  date: 'October 15, 2024',
  readTime: '5 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b7633f7872d71da442636e_66fc71998d968d8119460b67-homa-appliances-pWUyHVJgLhg-unsplash.jpg'
}, {
  slug: 'erp-is-dead-long-liver-erp',
  title: 'ERP is Dead - Long Live ERP',
  excerpt: "There's been a theory that ERP is going the way of the dinosaur, to be replaced by a frankenstein of SaaS solutions. With recent massive fundings, this theory doesn't seem to be panning out.",
  date: 'October 15, 2024',
  readTime: '4 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b762d01230118dd91dedf8_erp_tombstone.jpg'
}, {
  slug: 'inventory-management-what-do-i-have',
  title: 'Inventory Management: What do I have?',
  excerpt: "The first question that an inventory management system has to answer is: What inventory do I have? Here's how to track parts, locations, and quantities effectively.",
  date: 'October 15, 2024',
  readTime: '6 min read',
  category: 'Inventory',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b764060b01c8ace0a0e09c_66623070e569a0ec2951b6b4-ruchindra-gunasekara-GK8x_XCcDZg-unsplash.jpg'
}, {
  slug: 'inventory-management-forecasting',
  title: 'Inventory Management: Forecasting',
  excerpt: "Once you know what parts you're tracking and where they are, what do you do with that information? First you need to understand what you're using — and then plan what to buy next.",
  date: 'October 15, 2024',
  readTime: '4 min read',
  category: 'Inventory',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b763cb7b5d1973b30c0056_667654688d060396e03d182a-helcim-payments-p_zZditHECg-unsplash.jpg'
}, {
  slug: 'project-costing---why-is-it-so-difficult',
  title: 'Project Costing - Why is it so difficult',
  excerpt: 'Determining the entire cost of a project is extremely difficult. You need to track tasks, expenses, time, and contracts — and integrate that information together.',
  date: 'October 15, 2024',
  readTime: '4 min read',
  category: 'Manufacturing',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b7638e4820d28d5cfda86a_66e9e4c7a1fe965b31180a76-daria-nepriakhina-zoCDWPuiRuA-unsplash.jpg'
}, {
  slug: 'what-does-customizable-software-actually-mean',
  title: 'What does customizable software actually mean?',
  excerpt: 'Every software company offers some level of customization. But how does Thruline stand out? We think about customization like the levels of self-driving cars.',
  date: 'October 15, 2024',
  readTime: '4 min read',
  category: 'ERP',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b764425127d4c5769c9f48_6648edd002e10409977ba88a-campaign-creators---kQ4tBklJI-unsplash.jpg'
}, {
  slug: 'thruline-announcement',
  title: 'Thruline Announcement',
  excerpt: "At Thruline we're building an ERP system that every small business can (actually) afford, with an implementation timeframe measured in days, not months.",
  date: 'October 15, 2024',
  readTime: '2 min read',
  category: 'Company',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/67b7647cd5f6bdacb033ab4d_66443745d22843965154e625-Funding%20Announcement.png'
}, {
  slug: 'thruline-case-study-connecting-engineering-and-erp-data-for-real-world-analytics',
  title: 'Connecting Engineering and ERP Data for Real-World Analytics',
  excerpt: "When you're dealing with complex engineering projects, having data scattered across different systems isn't just inconvenient — it's a roadblock to making informed decisions. See how one engineer used Thruline's API to bridge the gap.",
  date: 'December 2, 2025',
  readTime: '6 min read',
  category: 'Case Study',
  image: 'https://cdn.prod.website-files.com/67b56d3f150af8f39e4672fc/692e80024d03440a7693513b_D05qzqBZCRv.webp'
}, {
  slug: 'the-erp-factory-thesis',
  title: 'The ERP Factory Thesis: Why We Built Thruline',
  excerpt: "The traditional ERP implementation model is broken. Discovery takes months, costs spiral, and the result is software that doesn't match how your team actually works. We built Thruline to fix that — here's the thesis behind the company.",
  date: 'February 15, 2026',
  readTime: '8 min read',
  category: 'Company',
  image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&q=80&w=800&h=400'
}];
function parseDate(dateStr: string): Date {
  return new Date(dateStr);
}
function getMonthYearKey(dateStr: string): string {
  const d = parseDate(dateStr);
  if (d.getFullYear() < 2025) {
    return '2024';
  }
  return d.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  });
}
function groupAndSortPosts() {
  const sorted = [...posts].sort((a, b) => parseDate(b.date).getTime() - parseDate(a.date).getTime());
  const groups: {
    key: string;
    sortDate: number;
    posts: typeof posts;
  }[] = [];
  const groupMap = new Map<string, typeof posts>();
  for (const post of sorted) {
    const key = getMonthYearKey(post.date);
    if (!groupMap.has(key)) {
      const group: typeof posts = [];
      groupMap.set(key, group);
      groups.push({
        key,
        sortDate: parseDate(post.date).getTime(),
        posts: group
      });
    }
    groupMap.get(key)!.push(post);
  }
  return groups;
}
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const groupedPosts = useMemo(() => groupAndSortPosts(), []);
  return <div className="min-h-screen bg-navy text-white pt-32 pb-20" data-id="element-680">
      <div className="max-w-5xl mx-auto px-6" data-id="element-681">
        {/* Header */}
        <motion.div className="text-center mb-16" initial="hidden" animate="visible" variants={fadeUp} transition={{
        duration: 0.5
      }} data-id="element-682">
          <span className="text-violet-electric text-xs font-semibold tracking-[0.2em] uppercase block mb-4" data-id="element-683">
            Blog
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-6" data-id="element-684">
            Insights & Updates
          </h1>
          <p className="text-lg text-white/55 max-w-2xl mx-auto" data-id="element-685">
            Thoughts on manufacturing, ERP, and building software for the
            physical world.
          </p>
        </motion.div>

        {/* Grouped Posts by Month */}
        <div className="space-y-16" data-id="element-686">
          {groupedPosts.map((group, groupIndex) => <motion.section key={group.key} initial="hidden" animate="visible" variants={fadeUp} transition={{
          duration: 0.5,
          delay: 0.1 + groupIndex * 0.05
        }} data-id="element-687">
              {/* Month/Year Header */}
              <div className="flex items-center gap-4 mb-8" data-id="element-688">
                <h2 className="text-lg font-semibold text-white/80 whitespace-nowrap" data-id="element-689">
                  {group.key}
                </h2>
                <div className="h-px flex-1 bg-white/[0.08]" data-id="element-690" />
              </div>

              {/* Posts in this month */}
              <div className="space-y-6" data-id="element-691">
                {group.posts.map(post => <Link key={post.slug} to={`/resources/blog/${post.slug}`} className="group block rounded-2xl border border-white/[0.06] bg-white/[0.02] overflow-hidden hover:border-violet-electric/20 hover:bg-white/[0.04] transition-all duration-300" data-id="element-692">
                    <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-693">
                      <div className="h-56 md:h-auto md:min-h-[240px] overflow-hidden" data-id="element-694">
                        <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-695" />
                      </div>
                      <div className="p-7 md:p-10 flex flex-col justify-center" data-id="element-696">
                        <span className="text-violet-electric text-xs font-semibold tracking-widest uppercase mb-3" data-id="element-697">
                          {post.category}
                        </span>
                        <h3 className="text-xl md:text-2xl font-bold text-white mb-3 group-hover:text-violet-electric transition-colors leading-tight" data-id="element-698">
                          {post.title}
                        </h3>
                        <p className="text-white/50 text-sm leading-relaxed mb-5 line-clamp-3" data-id="element-699">
                          {post.excerpt}
                        </p>
                        <div className="flex items-center gap-4 text-white/30 text-sm" data-id="element-700">
                          <span className="flex items-center gap-1.5" data-id="element-701">
                            <CalendarIcon className="w-3.5 h-3.5" data-id="element-702" />
                            {post.date}
                          </span>
                          <span className="flex items-center gap-1.5" data-id="element-703">
                            <ClockIcon className="w-3.5 h-3.5" data-id="element-704" />
                            {post.readTime}
                          </span>
                        </div>
                        <div className="mt-5" data-id="element-705">
                          <span className="inline-flex items-center gap-2 text-violet-electric text-sm font-medium group-hover:gap-3 transition-all" data-id="element-706">
                            Read article
                            <ArrowRightIcon className="w-4 h-4" data-id="element-707" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>)}
              </div>
            </motion.section>)}
        </div>
      </div>
    </div>;
}